<template>
    <div>
        <main-layout-content>
            <template #content>
                <common-page-plain>
                    <common-content-wrapper width="medium">
                        <activate-member-form></activate-member-form>
                    </common-content-wrapper>
                </common-page-plain>
            </template>
        </main-layout-content>
    </div>
</template>

<script>
    import MainLayoutContent from 'components/layouts/layout-content/MainLayoutContent'
    import ActivateMemberForm from 'components/forms/admin/ActivateMemberForm'

    export default {
        components: { MainLayoutContent, ActivateMemberForm },
    }
</script>
